import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { IconButtonComponent } from '@components/buttons/icon-button/icon-button.component';
import { ButtonComponent } from '../../buttons/button/button.component';

export interface AccessabilityDialogData {
  title?: string;
  message?: string;
  redirectLink?: string;
  linkTitle?: string;
  isForceClose?: boolean;
}

@Component({
  selector: 'app-accessability-dialog',
  imports: [MatDialogModule, ButtonComponent, IconButtonComponent],
  templateUrl: './accessability-dialog.component.html',
  styleUrls: ['./accessability-dialog.component.scss'],
})
export class AccessabilityDialogComponent {
  data = inject<AccessabilityDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<AccessabilityDialogComponent>);
  private readonly DEFAULT_MESSAGE = 'برای دسترسی به این صفحه باید به شیدا وارد شوید';
  private readonly DEFAULT_REDIRECT_LINK = '/auth';
  private readonly DEFAULT_LINK_TITLE = 'ورود و ثبت‌نام';
  private readonly DEFAULT_TITLE = 'ابتدا وارد شوید';

  constructor() {
    this.data = {
      title: this.data?.title ?? this.DEFAULT_TITLE,
      message: this.data?.message ?? this.DEFAULT_MESSAGE,
      redirectLink: this.data?.redirectLink ?? this.DEFAULT_REDIRECT_LINK,
      linkTitle: this.data?.linkTitle ?? this.DEFAULT_LINK_TITLE,
      isForceClose: this.data?.isForceClose ?? false,
    };
    this.dialogRef.addPanelClass('accessability-dialog');
  }

  close() {
    this.dialogRef.close();
  }
}
